import React from 'react';

const SettingsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9.80005" cy="9.7998" r="2.5" stroke="#555B67" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 11.2913V8.61087L17.4348 8.49739C16.8066 8.45149 16.2582 8.0546 16.0183 7.47217V7.45261C15.7761 6.86997 15.8836 6.20052 16.2961 5.72304L17.3213 4.54913L15.4157 2.63957L14.2417 3.66478C13.7643 4.07726 13.0948 4.1848 12.5122 3.94261H12.4926C11.9126 3.71247 11.5147 3.17174 11.4674 2.54957L11.3383 1H8.65783L8.54435 2.54174C8.49775 3.16693 8.10033 3.71148 7.51913 3.94652C6.93649 4.18871 6.26704 4.08118 5.78957 3.6687L4.61565 2.64348L2.68652 4.52174L3.71174 5.69565C4.12422 6.17313 4.23175 6.84258 3.98957 7.42522C3.76263 8.0284 3.20764 8.44617 2.56522 8.49739L1 8.61087V11.2913L2.56522 11.4087C3.19345 11.4546 3.74183 11.8515 3.98174 12.4339V12.4535C4.22393 13.0361 4.11639 13.7056 3.70391 14.183L2.6787 15.357L4.57261 17.2509L5.74652 16.2257C6.224 15.8132 6.89345 15.7056 7.47609 15.9478H7.49565C8.08115 16.1988 8.47698 16.7562 8.52087 17.3917L8.65783 19H11.3383L11.4517 17.4152C11.4978 16.7843 11.8939 16.2324 12.477 15.987H12.4965C13.0784 15.7437 13.7478 15.8497 14.2261 16.2609L15.4 17.2822L17.2939 15.3843L16.2687 14.2104C15.8562 13.733 15.7487 13.0635 15.9909 12.4809V12.4613C16.2268 11.8597 16.7898 11.4492 17.4348 11.4087L19 11.2913Z"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default SettingsIcon;
